import React from 'react'

export default function PowerCountcompo({count}) {
  return (
    <div style={{color:'white',margin:'10px',marginLeft:'20px'}}>
      <p>{ count}</p>
    </div>
  )
}
